import { environment } from '../../environments/environment';

export const segmentEnabled = environment.SEGMENT_ENABLED || 'FALSE';
export const segmentKey = environment.SEGMENT_KEY || 'uSMKJDYuJOwmIYoJOaTJvvFY6KF9RN8F';

export function isSegmentEnabled(): boolean {
    return segmentEnabled === 'TRUE';
}
